import { useMemo } from 'react'
import Checkbox from '@mui/material/Checkbox'
import FormControlLabel from '@mui/material/FormControlLabel'
import TextField from '@mui/material/TextField'
import { string, any } from 'prop-types'
import { CvsAutoComplete } from '@components'

export const FieldDetection = ({
  type = 'string',
  optionParameter: _optionParameter,
  slug: _slug,
  ...restProps
}) => {
  const types = useMemo(() => ({
    bool: ({ onChange, label, value, ...rest }) => (
      <FormControlLabel
        label={label}
        onChange={() => onChange(!value)}
        control={<Checkbox checked={value} {...rest} />}
      />
    ),
    string: ({ onChange, ...rest }) => (
      <TextField
        fullWidth
        style={{ paddingRight: '2em' }}
        variant="outlined"
        onChange={e => onChange(e.target.value)}
        {...rest}
      />
    ),
    list: ({ listOptions, onChange, ...props }) => {
      return (
        <CvsAutoComplete onChange={e => onChange(e.value)} options={listOptions || []} {...props} />
      )
    },
  }))
  const Field = useMemo(() => types[type] || TextField, [type])

  return <Field {...restProps} />
}

FieldDetection.propTypes = {
  type: string,
  slug: string,
  optionParameter: any,
}
